const passwordRecoveryConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('password-recovery', {
      url: '/password-recovery?e&t',
      template: '<app-password-recovery></app-password-recovery>',
      access: {
        loginRequired: false,
      },
      resolve: {
        // used to set the page title
        $title: () => 'Password recovery',
      },
    });
};

export default passwordRecoveryConfig;



// WEBPACK FOOTER //
// ./src/modules/password-recovery/password-recovery.config.js